import React from 'react';
import title from '../../assets/images/footer/footer-title.svg';
const FooterTitle = () => {
  return (
    <img src={title} alt='Arwine Tours' style={{width: '16rem'}} />
  );
};

export default FooterTitle;